export default "__VITE_ASSET__awG1dfQq__"